import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const SignUp = () => {
  return (
    <div>
      <Box sx={{ px: 4, pt: 8 }}>
        <Typography variant="h3" className="sectionTitle">
          Signup
        </Typography>
        <Typography sx={{ my: 4 }} variant="body1">
          SivooTV+ is live! Although we cannot offer individual retail accounts just yet, we are able to offer bulk and hotel accounts&mdash;request a sales rep <Link to="https://sivoo.com/contact" target="_blank">contact you</Link> to explain the details. Individual subscriptions should be available later in 2024. When that time comes (and we're hoping it's sooner...), a signup and payment collection form will display below. Please check back regularly as we are getting close!
          {/*Using the form below, complete your subscription information and finalize with your payment.*/}
        </Typography>
        <Box>
          {/* <iframe
            src="https://sivoo.com"
            title="Signup"
            width="100%"
            height="500px"
            allowFullScreen
          ></iframe> */}
        </Box>
      </Box>
    </div>
  );
};

export default SignUp;
